import styles from "../styles/App.module.css";

type StatusBlockProps = {
  message: string;
  recoveryAction?: string;
  tone?: "info" | "error" | "success";
};

export const DEFAULT_ERROR_RECOVERY_ACTION =
  "请使用返回上一层或返回主菜单，稍后再试。";

export function StatusBlock({
  message,
  recoveryAction,
  tone = "info",
}: StatusBlockProps) {
  const effectiveRecoveryAction =
    recoveryAction ?? (tone === "error" ? DEFAULT_ERROR_RECOVERY_ACTION : "");

  return (
    <p
      className={`${styles.statusBlock} ${styles[tone]}`}
      role={tone === "error" ? "alert" : "status"}
    >
      {message}
      {effectiveRecoveryAction ? <> {effectiveRecoveryAction}</> : null}
    </p>
  );
}
